var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_68)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 0C38.7979 0 50 11.2021 50 25C50 38.7979 38.7979 50 25 50C11.2021 50 0 38.7979 0 25C0 11.2021 11.2021 0 25 0ZM17.1839 39.0499V19.5264H10.6933V39.0499H17.1839ZM40.5843 39.0499V27.854C40.5843 21.857 37.3824 19.0673 33.1127 19.0673C29.6698 19.0673 28.1276 20.9607 27.2642 22.2906V19.5264H20.7752C20.8612 21.3581 20.7752 39.0499 20.7752 39.0499H27.2641V28.1466C27.2641 27.563 27.3061 26.9796 27.478 26.5625C27.9463 25.397 29.0148 24.1896 30.8076 24.1896C33.1547 24.1896 34.095 25.9806 34.095 28.604V39.0499H40.5843ZM13.9824 10.1123C11.7617 10.1123 10.3108 11.5723 10.3108 13.4858C10.3108 15.3591 11.7176 16.8593 13.8965 16.8593H13.9384C16.2016 16.8593 17.6103 15.3591 17.6103 13.4858C17.5683 11.5723 16.2017 10.1123 13.9824 10.1123Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c229c75c25aac50c238a8943be5da6c1.svg";
export { ForwardRef as ReactComponent };